import { render, staticRenderFns } from "./CommercialProductExtraInfo.vue?vue&type=template&id=07f1d666&scoped=true&"
import script from "./CommercialProductExtraInfo.vue?vue&type=script&lang=js&"
export * from "./CommercialProductExtraInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1d666",
  null
  
)

export default component.exports